export default __webpack_public_path__ + "ae7238c7ed35133a1b4472fd326a4fe5.svg";